import { BasePayloadMapper } from '@ps/utils';
import { Quota } from '@ps/survey-utils';

import { QuotaPayloadDto } from '../dtos/survey-quota.dto';
import { QuotaCriteriaPayloadMapper } from './survey-quota-payload.mapper';

export class QuotaPayloadMapper extends BasePayloadMapper<
  Quota,
  QuotaPayloadDto
> {
  private readonly _criteriaMapper = new QuotaCriteriaPayloadMapper();

  public toPayload(quota: Quota): QuotaPayloadDto {
    return {
      buyer_quota_id: quota.buyerQuotaId,
      required_count: quota.requiredCount,
      flexible: quota.flexible,
      group_key: quota.groupKey,
      criteria: this._criteriaMapper.toPayload(quota.criteria),
      maximum: quota.maximum,
      minimum: quota.minimum,
      percentage: quota.percentage,
      quota_category: quota.quotaCategory,
    };
  }
}
